export function throwOnResponseError(response) {
    if (!response.ok) {
        const error = new Error(
            `status ${response.status}, statusText: ${response.statusText}`
        );
        error.status = response.status ?? 500;
        error.statusText = response.statusText;
        throw error;
    }
}
